import React, { useState } from 'react';
import { loginUrl2 } from '../../../utils/staticPageUrls';
import { Layout, Collapse, Button, Table } from 'antd';
import { ReactComponent as Minus } from '../../../assets/icons/minus.svg';
import { ReactComponent as Plus } from '../../../assets/icons/plus.svg';
// import { ReactComponent as PhoneIcon } from '../../../assets/icons/phoneIcon.svg';
import Guide from '../../../assets/documents/ΦΕΚ_Β_6969_Αντλία Θερμότητας _Θερμοσίφωνα.pdf';
import FAQ from '../../../assets/documents/Συχνές Ερωτήσεις _v01.pdf';
import DeMinimins from '../../../assets/documents/Πρότυπο Υ.Δ De Minimis.docx';
import GoodWork from '../../../assets/documents/Υπόδειγμα ΥΔ Καλής Εκτέλεσης Εργασιών.docx';
import RespDeclarOwner from '../../../assets/documents/Υπόδειγμα_Υπεύθυνης_Δήλωσης_Συναίνεσης_Ιδιοκτήτη.docx';

import bot_img from '../../../assets/icons/Final_Chatobot_RGB.SVG';
import SubmitLanding from '../../../assets/icons/SubmitLanding.svg';
import HeaderLanding from './staticsHeader';
import Footer from './staticFooter';
import isEmpty from 'lodash/isEmpty';

const { Content } = Layout;
const { Panel } = Collapse;

const StaticPage1 = () => {

  const documents = [
    {
      category: 'Κοινή Υπουργική Απόφαση',
      documents: [
        // {
        // 	label: '2η Τροποποίηση της Κοινής Υπουργικής Απόφασης',
        //   date: '16/12/2022',
        // 	link: SmartReadinessPdf
        // },
      ],
    },
    {
      category: 'Οδηγός Προγράμματος',
      documents: [
        {
          label: 'Οδηγός Προγράμματος',
          date: '13/01/2025',
          link: Guide,
        },
      ],
    },
    {
      category: 'Διάφορα',
      documents: [
        {
          label: 'Συχνές Ερωτήσεις',
          // date: '10/06/2022',
          link: FAQ
        },
        {
          label: 'Υπόδειγμα ΥΔ Καλής Εκτέλεσης Εργασιών',
          // date: '10/06/2022',
          link: GoodWork
        },
        {
          label: 'Υπόδειγμα Υπεύθυνης Δήλωσης Συναίνεση Ιδιοκτήτη',
          // date: '10/06/2022',
          link: RespDeclarOwner
        },
        {
          label: 'Πρότυπο ΥΔ DE Minimis',
          // date: '10/06/2022',
          link: DeMinimins
        },

      ],
    },
  ];

  const columnsA = [
    {
      title: '',
      dataIndex: 'header1',
      key: 'header1',
      width: 100,
      fixed: 'left',
    },
    {
      title: `Κατηγορία A`,
      children: [
        {
          title: 'Επιταγή προϊόντος',
          children: [
            {
              title: 'Εισοδηματικό Κριτήριο 1',
              dataIndex: 'col1',
              key: 'col1',
              width: 150,
            },
            {
              title: 'Εισοδηματικό Κριτήριο 2',
              dataIndex: 'col2',
              key: 'col2',
              width: 150,
            },
          ],
        },
        {
          title: 'Επιταγή υπηρεσιών',
          children: [
            {
              title: 'Εισοδηματικό Κριτήριο 1',
              dataIndex: 'col3',
              key: 'col3',
              width: 150,
            },
            {
              title: 'Εισοδηματικό Κριτήριο 2',
              dataIndex: 'col4',
              key: 'col4',
              width: 150,
            },
          ],
        },
      ],
    },
  ];

  const columnsB = [
    {
      title: '',
      dataIndex: 'header1',
      key: 'header1',
      width: 100,
      fixed: 'left',
    },
    {
      title: `Κατηγορία B`,
      children: [
        {
          title: 'Χωρίς Εισοδηματικά Κριτήρια',
          children: [
            {
              title: 'Επιταγή προϊόντος',
              dataIndex: 'col1',
              key: 'col1',
              width: 300,
            },
            {
              title: 'Επιταγή υπηρεσιών',
              dataIndex: 'col2',
              key: 'col2',
              width: 300,
            },
          ],
        },
      ],
    },
  ];

  const dataA = [
    {
      key: '1',
      header1: 'Ποσοστό ενίσχυσης (%)',
      col1: '60%',
      col2: '50%',
      col3: '60%',
      col4: '50%',
    },
    {
      key: '2',
      header1: 'Μέγιστη ονομαστική αξία επιταγών (€)',
      col1: '840',
      col2: '600',
      col3: '180',
      col4: '100',
    },
  ];

  const dataB = [
    {
      key: '1',
      header1: 'Ποσοστό ενίσχυσης (%)',
      col1: '50%',
      col2: '50%',
    },
    {
      key: '2',
      header1: 'Μέγιστη ονομαστική αξία επιταγών (€)',
      col1: '5000',
      col2: '1000',
    },
  ];



  const [generalInfo, setGeneralInfo] = useState(true);
  const [docsTab, setDocsTab] = useState(false);
  const [activeKey, setActiveKey] = useState();
  const [showBot, setShowBot] = useState(false);
  const [minimizeBot, setMinimizeBot] = useState(false);

  // const handleMinimize = () => {
  //   setShowBot(false);
  //   setMinimizeBot(true);
  // };

  const handleOpen = () => {
    setShowBot(true);
    setMinimizeBot(false);
  };

  return (
    <Layout id="landing-page">
      <HeaderLanding
        setShowBot={setShowBot}
        showBot={showBot}
        className="header-landing"
      />
      <Content>
        <div className="sub-header-image">
          <div className="hero-space">
            <div className="hero-space-body">
              <div className="left-hero-space">
                <div className="hero-text-space">
                  <span className="left-hero-text">Η πλατφόρμα άνοιξε!</span>
                </div>
                <div className="title-display-space">
                  <div id="hero-texts">
                    <div className="title-text-1">
                      {/* <FirstIcon /> */}
                      <div className="title-text">
                        <span>
                          {/* <a href="/go-beyond/login">Αποκτήστε επιχορήγηση</a>{' '} */}
                          Αποκτήστε επιχορήγηση για αντικατάσταση ενεργοβόρων 
                          ηλεκτρικών θερμοσίφωνων, με νέους σύγχρονης τεχνολογίας ηλιακούς 
                          θερμοσίφωνες ή/και με σύστημα αντλίας θερμότητας.
                        </span>
                      </div>
                    </div>
                    <div className="title-text-1">
                      <span className="title-text">Λίστα Εξοπλισμού</span>
                    </div>
                    <div className="title-text-1">
                      <span className="title-text">Λίστα Προμηθευτών</span>
                    </div>
                    <div className="title-text-1">
                      {/* <ThrirdIcon /> */}
                      <span className="title-text">
                        Είστε Προμηθευτής;{' '}
                        {/* <a href="go-beyond/login">Μητρώο Προμηθευτών</a> */}
                        Πραγματοποιήστε την εγγραφή σας στο Μητρώο Προμηθευτών
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="hero-footer">
              {
                <div id="hero-text">
                  To Πρόγραμμα «ΑΛΛΑΖΩ ΣΥΣΤΗΜΑ ΘΕΡΜΑΝΣΗΣ ΚΑΙ ΘΕΡΜΟΣΙΦΩΝΑ»  
                  υλοποιείται στο πλαίσιο του Εθνικού Σχεδίου Ανάκαμψης και 
                  Ανθεκτικότητας Ελλάδα 2.0 με τη χρηματοδότηση της Ευρωπαϊκής Ένωσης - NextGenerationEU
                </div>
              }
            </div>
          </div>
        </div>
        <div className="sub-header-container">
          {/* <div className="sub-header-wifi">
            <Wifi />
          </div> */}
          <div className="sub-header mb-5">
            <h3 className="sub-header-top-text">1 ΒΗΜΑ ΓΙΑ ΝΑ ΚΑΝΕΤΕ</h3>{' '}
            <h1 className="sub-header-btm-text">AITHΣH</h1>
          </div>
        </div>

        <div
          id="iframe"
          className="bot-minimize"
          style={{ display: !showBot && minimizeBot ? 'block' : 'none' }}
        >
          <div>
            <div>
              <a onClick={() => handleOpen()}>
                <img src={bot_img} alt="bot_img" width={100} height={100} />
              </a>
            </div>
          </div>
        </div>

        <div className="badges-container">
          <div className="badges">
            {/* <div
              className="badges-icon"
              style={{
                marginTop: '1rem',
              }}
            >
              2
            </div> */}
            <div className="badges-content">
              <h2 className="badges-title">Υποβολή Αίτησης</h2>
              <img
                src={SubmitLanding}
                alt="Submit Icon"
                style={{
                  width: '4.46375rem',
                  height: '4.761875rem',
                  marginRight: '0.5rem',
                }}
              />
              <div className="badges-text-container">
                <p
                  className="badges-text"
                  style={{ color: '#46616B', fontSize: '1.375rem' }}
                >
                  Για να υποβάλετε αίτηση Προμηθευτών, συνδεθείτε με τους κωδικούς Taxisnet
                  (username & password).
                </p>

                {process.env.REACT_APP_LANDING_LOGIN_TO_PLATFORM === 'true' && <a
                  href={loginUrl2}
                  className="badges-button"
                  style={{
                    marginTop: '1rem',
                    borderRadius: '23px',
                  }}
                >
                  Είσοδος στην πλατφόρμα →
                </a>}
              </div>
            </div>
          </div>
        </div>

        <div className="main-content">
          <div className="collapse-header">
            <Button
              className={generalInfo ? 'active-page' : ''}
              id="staticButtons"
              onClick={() => {
                setGeneralInfo(true);
                setDocsTab(false);
              }}
            >
              <span className='badge-span'>
                ΓΕΝΙΚΕΣ ΠΛΗΡΟΦΟΡΙΕΣ
              </span>
            </Button>
            <Button
              className={docsTab ? 'active-page' : ''}
              id="staticButtons"
              onClick={() => {
                // setGeneralInfo(false);
                setDocsTab(!docsTab);
              }}
            >
              <span className='badge-span'>
                ΕΓΓΡΑΦΑ ΠΡΟΓΡΑΜΜΑΤΟΣ
              </span>
            </Button>
          </div>
          {docsTab &&
            !isEmpty(documents) &&
            !documents?.every(category => isEmpty(category?.documents)) && (
              <div className="documents-content">
                <h1 className="documents-header">Έγγραφα Προγράμματος</h1>
                <div className="documents-items">
                  {documents?.map(item => (
                    <div className="docs">
                      <h2 className="documents-category">{item.category}</h2>
                      <div className="documents-info">
                        {item.documents?.map(item => (
                          <>
                            <a
                              target="_blank"
                              rel="noreferrer"
                              href={item.link}
                            >
                              {item.label}
                            </a>
                            <p>{item.date}</p>
                          </>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          {generalInfo && (
            <div id="landing-info">
              <Collapse
                key="1"
                className="main-content__collapse"
                expandIcon={({ isActive }) => (isActive ? <Minus /> : <Plus />)}
                expandIconPosition={'right'}
                onChange={e =>
                  activeKey === '1' ? setActiveKey('') : setActiveKey('1')
                }
                activeKey={activeKey}
              >
                <Panel
                  header={
                    <text style={{ color: 'white' }}>
                      ΣΚΟΠΟΣ ΚΑΙ ΑΝΤΙΚΕΙΜΕΝΟ
                    </text>
                  }
                  key="1"
                >
                  <div>
                    <b style={{ fontSize: '1.5rem' }}>
                      ΣΚΟΠΟΣ ΚΑΙ ΑΝΤΙΚΕΙΜΕΝΟ{' '}
                    </b>
                    <br></br>
                    <br></br>
                    <p>
                      Το Πρόγραμμα «Αλλάζω Σύστημα Θέρμανσης και Θερμοσίφωνα» επιχορηγεί νοικοκυριά για 
                      την αντικατάσταση ενεργοβόρων ηλεκτρικών θερμοσίφωνων, με νέους σύγχρονης τεχνολογίας 
                      ηλιακούς θερμοσίφωνες ή/και με σύστημα αντλίας θερμότητας.  
                      Το πρόγραμμα περιλαμβάνει:
                    </p>
                    <p>
                      <ul>
                        <li>
                          Την επιδότηση αγοράς νέου ηλιακού́ θερμοσίφωνα
                          σύγχρονης τεχνολογίας (Επιλέξιμος Εξοπλισμός
                          Κατηγορίας Α).
                        </li>
                        <li>
                          Την επιδότηση αγοράς νέου συστήματος αντλίας
                          θερμότητας θέρμανσης (συμπεριλαμβάνεται η εξωτερική
                          μονάδα, fan coil, σωληνώσεις) (Επιλέξιμος Εξοπλισμός
                          Κατηγορίας Β).
                        </li>
                        <li>
                          Επιδότηση της δαπάνης για την εκτέλεση αναγκαίων συμπληρωματικών 
                          εργασιών τοποθέτησης επιλέξιμου εξοπλισμού (π.χ. κόστος μεταφοράς, 
                          κόστος τοποθέτησης, αναλώσιμα, εξαρτήματα, smart system (χρονοδιακόπτης) κλπ.) 
                          (Επιλέξιμη Δαπάνη των Κατηγοριών Α και Β).{' '}
                        </li>
                      </ul>
                    </p>
                    <p>
                      Βασικοί στόχοι του Προγράμματος είναι η αύξηση των
                      ανανεώσιμων πηγών ενέργειας (ΑΠΕ) και η εξοικονόμηση
                      οικονομικών πόρων από τη μείωση της κατανάλωσης ενέργειας.
                      Συγκεκριμένα, η χρήση ΑΠΕ για τη παραγωγή ζεστού νερού
                      χρήσης αναμένεται να μειώσει σημαντικά το μέσο ενεργειακό
                      κόστος της ελληνικής οικογένειας και παράλληλα η
                      χαμηλότερη ζήτηση ηλεκτρικής ενέργειας συνεπάγεται σε
                      μικρότερη παραγωγή από ορυκτά καύσιμα ή μη ανανεώσιμες
                      πηγές.
                    </p>
                    <p>
                      Ένας ακόμα βασικός στόχος του Προγράμματος είναι η μείωση
                      χρήσης συστημάτων θέρμανσης με βάση τα ορυκτά καύσιμα και
                      τη βιομάζα που επιβαρύνουν σημαντικά την ατμοσφαιρική
                      ρύπανση με αιωρούμενα σωματίδια. Μεγαλύτερο τμήμα του
                      προϋπολογισμού του Προγράμματος θα διατεθεί προς τους
                      ωφελούμενους στις Περιφέρειες Κεντρικής Μακεδονίας και
                      Ηπείρου όπου με βάση στοιχεία μετρήσεων ατμοσφαιρικής
                      ρύπανσης των τελευταίων πέντε (5) χρόνων, καταγράφεται
                      συχνή υπέρβαση των μέγιστων επιτρεπτών ορίων σωματιδιακής
                      ρύπανσης αρκετές φορές ετησίως σε σχέση με τις υπόλοιπες
                      Περιφέρειες της Ελλάδας.
                    </p>
                  </div>
                </Panel>
              </Collapse>

              <Collapse
                key="2"
                className="main-content__collapse"
                expandIcon={({ isActive }) => (isActive ? <Minus /> : <Plus />)}
                expandIconPosition={'right'}
                onChange={e =>
                  activeKey === '2' ? setActiveKey('') : setActiveKey('2')
                }
                activeKey={activeKey}
              >
                <Panel
                  header={
                    <text style={{ color: 'white' }}>
                      ΔΙΚΑΙΟΥΧΟΙ ΤΟΥ ΠΡΟΓΡΑΜΜΑΤΟΣ
                    </text>
                  }
                  key="2"
                >
                  <div>
                    <b style={{ fontSize: '1.5rem' }}>
                      ΔΙΚΑΙΟΥΧΟΙ ΤΟΥ ΠΡΟΓΡΑΜΜΑΤΟΣ
                    </b>
                    <br></br>
                    <br></br>
                    <p>
                      Δυνητικοί ωφελούμενοι του Προγράμματος είναι οικιακοί
                      καταναλωτές που επιθυμούν να τοποθετήσουν στην οικία τους
                      (ενοικιαζόμενη /δωρεάν παραχωρούμενη) ηλιακό θερμοσίφωνα
                      νέας τεχνολογίας ή/και νέου συστήματος αντλίας θερμότητας.
                    </p>
                    <p>
                      Στις ενοικιαζόμενες/δωρεάν παραχωρούμενες κατοικίες
                      εφαρμόζονται οι διατάξεις του Κανονισμού 2831/2023 της
                      Επιτροπής ΕΕ για τις ενισχύσεις ήσσονος σημασίας (de
                      minimis), όπου καθορίζονται τα όρια σώρευσης (300.000 €).
                      Από πλευράς ιδιοκτητών των ακινήτων, πριν τη χορήγηση της
                      ενίσχυσης, θα πρέπει να δηλωθεί υπεύθυνα η τήρηση όλων των
                      όρων που καθορίζονται στον Κανονισμό για ενισχύσεις
                      ήσσονος σημασίας 2831/2023 (de minimis) και για
                      οποιαδήποτε άλλη ενίσχυση ήσσονος σημασίας έχει ληφθεί
                      βάσει του εν λόγω Κανονισμού ή άλλων Κανονισμών για
                      ενισχύσεις ήσσονος σημασίας κατά τα τρία (3) τελευταία
                      έτη, σε συμμόρφωση με τα οριζόμενα στην παρ. 4 του άρθρου
                      6 του Κανονισμού. Υπόδειγμα της ανωτέρω δήλωσης
                      συμμόρφωσης με τον κανονισμό de minimis της οποίας
                      προστεθεί ως παράρτημα στον Οδηγό (Παράρτημα ΙV). Οι
                      αιτήσεις χρηματοδότησης υποβάλλονται από μεμονωμένα Φυσικά
                      Πρόσωπα τα οποία διαμένουν μόνιμα στην Ελλάδα. Προκειμένου
                      να υποβάλλει αίτηση ένα Φυσικό Πρόσωπο θα πρέπει να
                      συντρέχουν σωρευτικά οι κάτωθι προϋποθέσεις:
                    </p>
                    <p>
                      <ul>
                        <li>
                          Να διαθέτει υποχρεωτικά Αριθμό Φορολογικού Μητρώου,
                          καθώς και έγκυρους κωδικούς πρόσβασης στις
                          ηλεκτρονικές υπηρεσίες της ΑΑΔΕ, μέσω των οποίων
                          γίνεται η ταυτοποίηση των προσωπικών στοιχείων μέσω
                          ΟΠΣ.
                        </li>
                        <li>
                          Να έχει υποβάλει κατά το έτος αναφοράς (φορολογικό
                          έτος 2023) δήλωση φορολογίας εισοδήματος (Ε1), είτε ως
                          ΥΠΟΧΡΕΟΣ ατομικής ή κοινής δήλωσης, είτε εμμέσως ως
                          «ΣΥΖΥΓΟΣ/ΜΣΣ » σε περίπτωση κοινής δήλωσης. Η σχετική
                          δήλωση θα πρέπει να έχει εκκαθαριστεί.
                        </li>
                        <li>
                          Δεν είναι επιλέξιμοι ωφελούμενοι (Φυσικά Πρόσωπα που
                          υποβάλουν την αίτηση) οι οποίοι είχαν υποβάλει δήλωση
                          φορολογίας εισοδήματος κατά το έτος αναφοράς (2023) ως
                          κάτοικοι εξωτερικού.
                        </li>
                        <li>
                          Εξαρτώμενα μέλη που δεν υποβάλλουν αυτόνομα δήλωση
                          (δηλ. δεν είναι υπόχρεοι σε δική τους ατομική δήλωση)
                          δε δύνανται να υποβάλλουν αίτηση για τη συμμετοχή τους
                          στο Πρόγραμμα.
                        </li>
                      </ul>
                    </p>
                  </div>
                </Panel>
              </Collapse>

              <Collapse
                key="3"
                className="main-content__collapse"
                expandIcon={({ isActive }) => (isActive ? <Minus /> : <Plus />)}
                expandIconPosition={'right'}
                onChange={e =>
                  activeKey === '3' ? setActiveKey('') : setActiveKey('3')
                }
                activeKey={activeKey}
              >
                <Panel
                  header={
                    <text style={{ color: 'white' }}>ΠΟΣΟ ΕΝΙΣΧΥΣΗΣ</text>
                  }
                  key="3"
                >
                  <div>
                    <b style={{ fontSize: '1.5rem' }}>ΠΟΣΟ ΕΝΙΣΧΥΣΗΣ</b>
                    <br></br>
                    <br></br>
                    <p>Είναι οι παρακάτω πίνακες</p>
                    <p>
                      <Table
                        columns={columnsA}
                        dataSource={dataA}
                        bordered
                        pagination={false}
                        scroll={{ x: 800 }}
                      />
                    </p>
                    <p>
                      <Table
                        columns={columnsB}
                        dataSource={dataB}
                        bordered
                        pagination={false}
                        scroll={{ x: 800 }}
                      />
                    </p>
                  </div>
                </Panel>
              </Collapse>

              <Collapse
                key="4"
                className="main-content__collapse"
                expandIcon={({ isActive }) => (isActive ? <Minus /> : <Plus />)}
                expandIconPosition={'right'}
                onChange={e =>
                  activeKey === '4' ? setActiveKey('') : setActiveKey('4')
                }
                activeKey={activeKey}
              >
                <Panel
                  header={
                    <text style={{ color: 'white' }}>ΧΡΟΝΙΚΑ ΟΡΟΣΗΜΑ</text>
                  }
                  key="4"
                >
                  <div>
                    <b style={{ fontSize: '1.5rem' }}>ΧΡΟΝΙΚΑ ΟΡΟΣΗΜΑ</b>
                    <br></br>
                    <br></br>
                    <p>
                      Η έναρξη υποβολής Αιτήσεων χρηματοδότησης από δυνητικούς
                      ωφελούμενους θα ενεργοποιηθεί την 13-01-2025.
                    </p>
                    <p>
                      Η υποβολή των αιτήσεων θα πραγματοποιείται από 13-01-2025
                      έως 31-03-2025 κατόπιν ενημερωτικού δελτίου τύπου του
                      Υπουργείου Περιβάλλοντος και Ενέργειας.
                    </p>
                  </div>
                </Panel>
              </Collapse>

              <Collapse
                key="5"
                className="main-content__collapse"
                expandIcon={({ isActive }) => (isActive ? <Minus /> : <Plus />)}
                expandIconPosition={'right'}
                onChange={e =>
                  activeKey === '5' ? setActiveKey('') : setActiveKey('5')
                }
                activeKey={activeKey}
              >
                <Panel
                  header={
                    <text style={{ color: 'white' }}>
                     ΥΠΟΒΟΛΗΣ ΑΙΤΗΣΗΣ ΣΤΟ ΠΡΟΓΡΑΜΜΑ
                    </text>
                  }
                  key="5"
                >
                  <div>
                    <b style={{ fontSize: '1.5rem' }}>
                    ΥΠΟΒΟΛΗΣ ΑΙΤΗΣΗΣ ΣΤΟ ΠΡΟΓΡΑΜΜΑ
                    </b>
                    <br></br>
                    <br></br>
                    <p>
                      Προκειμένου να εκδοθεί το Voucher, θα πρέπει να
                      ακολουθηθούν τα παρακάτω βήματα:
                    </p>
                    <p>
                      Ωφελούμενοι:
                      <ol>
                        <li>
                          Να κάνουν εισαγωγή στην πλατφόρμα και υποβολή αίτησης
                        </li>
                        <li>
                          Εφόσον εγκριθεί τελικώς η αίτηση και λάβουν το κουπόνι στο <b>e-mail </b>
                          τους μπορούν να απευθυνθούν σε προμηθευτή ώστε να διαλέξουν
                          εξοπλισμό και υπηρεσίες.
                        </li>
                      </ol>
                    </p>
                    <p>
                      Προμηθευτές:
                      <ol>
                        <li>
                          Θα πρέπει να κάνουν την εγγραφή τους στο Μητρώο
                          Προμηθευτών και να δηλώσουν τον εξοπλισμό τους
                        </li>
                        <li>
                          Εφόσον η αίτηση εγκριθεί πλέον μπορούν να εισέλθουν
                          και στην πλατφόρμα του προγράμματος.
                        </li>
                      </ol>
                    </p>
                  </div>
                </Panel>
              </Collapse>
            </div>
          )}
        </div>
      </Content>
      <Footer />
    </Layout>
  );
};

export default StaticPage1;
